import workspace from "../workspace";
import Box from "./textBox/box";
import IText from "./textBox/iText";

export default class TextBox {
  // holds all our labels
  _posOnField = {};
  _placeholder = '';
  _design = {
    width: 50,
    height: 20,
    fillStyle: 'rgba(255,255,255, 0.7)', // transparent
  };
  box = null;
  text = null;

  //Initialize a new Box, add it, and invalidate the canvas
  addRect() {
    this.box = new Box(this._posOnField, this._design);
    this.text = new IText(this._placeholder, 'playregular', 0, 0, 100, 25, 0, this.box);
  }

  constructor(posOnField, placeholder, design) {
    this._posOnField = posOnField;
    this._placeholder = placeholder ? placeholder : this._placeholder;
    this._design = design ? design : this._design;
  }

  init() {
    this.addRect(this._design);
    workspace.textBoxManager.addTextBox(this);
  }

  deregisterEvents = () => {
    this.box.deregisterEvents();
    this.text.deregisterEvents();
  }

  reInitEvents = () => {
    this.box.reInitEvents();
    this.text.reInitEvents();
  }

  export() {
    return {
      posOnField: {
        x: this.box.posX,
        y: this.box.posY,
      },
      placeholder: this.text.modelText.txt,
      design: this.box.design
    }
  }

  import() {

  }
}


